/*
 * File per la definizione dei Controller Angular:
 * https://code.angularjs.org/1.5.8/docs/guide/controller
 */
define([
    'angular'
],
    function (angular) {

        var commonControllers = angular.module('commonControllers', []);

        /*
         * Le dipendenze dei Controller sono definite come stringhe per evitare problemi in caso di minificazione dei file .js
         * https://code.angularjs.org/1.5.8/docs/tutorial/step_05
         */
        commonControllers.controller('MessageCtrl', ['$scope', '$window', 'MessageService', '$log', '$filter', MessageCtrl]);
        commonControllers.controller('MenuCtrl', ['$location', '$log','CONSTANTS','FileProvider', MenuCtrl]);
        commonControllers.controller('UserCtrl', ['$log', '$window', '$q', 'CONSTANTS', 'ResourceService', 'MessageService', UserCtrl]);
        commonControllers.controller('VersionCtrl', ['$log', 'CONSTANTS', VersionCtrl]);
        commonControllers.controller('SpinnerController', ['$rootScope', '$log', 'CONSTANTS', SpinnerController]);
        commonControllers.controller('ErrorCtrl', ['$location', '$log', 'CONSTANTS', ErrorCtrl]);

        /* 
         * Definisco il Controller Message
         */
        function MessageCtrl($scope, $window, MessageService, LABELS, $log, $filter) {
            var vm = this;
            $scope.pagina = '#';

            /*
             * Intercetto l'evento che notifica l'aggiornamento dei messaggi.
             * L'evento viene emesso dal MessageService
             */
            $scope.$on("messagesUpdate", function (event) {
                vm.messages = MessageService.getAllMessages();
                /*
                 * Imposto il flag per la presenza di errori di tipo SYSTEM:
                 * se ci sono viene mostrato il link Invia segnalazione nella View
                 */
                vm.hasSystemError = MessageService.hasSystemError();
                /*
                 * Riporto lo scroll della pagina in alto per visualizzare il messaggio (se presenti)
                 */
                if (vm.messages && Object.keys(vm.messages).length > 0) {
                    $window.scrollTo(0, 0);
                    angular.element("#divMessages").focus();
                }
            });
        }

        /*
         * Definisco il Controller per la gestione delle voci attive nel menu
         */
        function MenuCtrl($location, $log,CONSTANTS,FileProvider) {
            var vm = this;

            vm.time = new Date().getTime();

            vm.refresh = function () {
                vm.time = new Date().getTime();
                return true;
            }

            vm.menuActive = function (page) {
                var active = false;
                try {
                    var current = $location.path();
                    if (current === undefined) {
                        return false;
                    }

                    current = '#' + current;
                    active = (current.indexOf(page) === 0);

                } catch (e) {
                }
                return active ? "active" : "";
            };
            
            vm.guida = function () {
               
                 var urlParams = {};
                FileProvider.openResponseInNewWindow(CONSTANTS.CONTEXT_REST_SERVICE + 'registrazione/guida-operativa', urlParams); 
            }

        }

        /*
         * Definisco il Controller per la gestione dell'area utente
         */
        function UserCtrl($log, $window, $q, CONSTANTS, ResourceService, MessageService) {
            var vm = this;

            vm.userName = "anonymous";
            vm.userData = { label: 'Seconda voce utente', value: 'valore' };
            vm.userLinks = [{ title: 'Link utente', href: '', icon: 'fa-font-awesome' },
            { title: 'Link utente', href: '', icon: 'fa-font-awesome' }];

            try {
                /*
                 * Richiamo una finta funzione di logout che rimanda alla pagina di Login,
                 * da ELIMINARE quando i servizi sono in sicurezza
                 */
               /*  vm.logout = function () {
                    if (confirm('Sei sicuro di voler uscire?')) {
                        $log.debug("Logout");
                        $window.location.href = CONSTANTS.LOGIN_PAGE;
                    }
                }; */
                /*
                 * Richiamo la funzione di logout, che dovra' invalidare le sessioni,
                 * da commentare per testare i servizi NON in sicurezza
                 */
                //	        vm.logout = function() {
                //        		if(confirm('Sei sicuro di voler uscire?')) {
                //		        	$log.debug("Logout");
                //		        	
                //		        	var logouts = CONSTANTS.LOGOUTS.map(function(URL) {			        		
                //		        		return ResourceService.logout.call(vm, URL);
                //		        	});
                //		        	
                //		        	$q.all(logouts).then(function() {
                //		        		$window.location.href = CONSTANTS.HOME_PAGE;
                //	        		},function(error) {
                //			        	$log.error(error);
                //			        });
                //        		}
                //	        };
                /*
                 * Richiamo il servizio che restituisce le informazioni utente da visualizzare nell'header,
                 * da commentare per testare i servizi NON in sicurezza
                 */
                //			ResourceService.getUserInfo().then(function(response) {
                //				vm.userName = response.userName;
                //		    },function(error) {
                //		    	$log.error(error);
                //		    });
            } catch (e) {
                MessageService.addSystemMessages(["Si è verificato un errore."]);
                MessageService.showMessages();
                throw e;
            }
        }

        /* 
         * Definisco il Controller per aggiungere il parametro con la versione nelle chiamate AJAX
         */
        function VersionCtrl($log, CONSTANTS) {
            var vm = this;
            vm.urlArgs = CONSTANTS.URL_ARGS;
        }

        function SpinnerController($rootScope, $log, CONSTANTS) {

            var spinnerVm = this;
            spinnerVm.jobs = {};
            spinnerVm.description = undefined;

            spinnerVm.count = function () {
                if (spinnerVm.jobs === undefined) {
                    return 0;
                }
                var numElements = 0;
                for (var prop in spinnerVm.jobs) {
                    if (spinnerVm.jobs.hasOwnProperty(prop))
                        ++numElements;
                }
                return numElements;
            };

            spinnerVm.startJob = function (jobName, jobDescription) {

                //Se è in corso un altro job non cambio la descrizione
                var changeDesc = false;
                if (jobDescription !== undefined && spinnerVm.count() === 0) {
                    changeDesc = true;
                }

                if (spinnerVm.jobs[jobName] === undefined) {
                    spinnerVm.jobs[jobName] = true; //job iniziato
                    angular.element("#spinner").show();
                    $log.debug("Job '" + jobName + "' avviato");
                }

                if (changeDesc) {
                    spinnerVm.description = jobDescription;
                }
            };

            spinnerVm.endJob = function (jobName) {

                //job esistente
                var numElements = spinnerVm.count();

                var exists = spinnerVm.jobs[jobName] !== undefined && spinnerVm.jobs[jobName] === true;

                //rimozione job dalla pila
                if (exists) {
                    spinnerVm.jobs[jobName] = undefined;
                    delete spinnerVm.jobs[jobName];
                }

                var isLast = numElements === 1;
                if (isLast) {
                    angular.element("#spinner").hide();
                    spinnerVm.description = undefined;
                    $log.debug("Job '" + jobName + "' terminato");
                }
            };

            // Fix per ricaricare il menu
            $rootScope.$on('startJob', function (event, jobName, jobDescription) {
                spinnerVm.startJob(jobName, jobDescription);
            });

            // Fix per ricaricare il menu
            $rootScope.$on('endJob', function (event, jobName) {
                spinnerVm.endJob(jobName);
            });
        }

        /*
         * Definisco il Controller per la gestione dell'area utente
         */
        function ErrorCtrl($location, $log, CONSTANTS) {
            var vm = this;

            vm.CONSTANTS = CONSTANTS;

        }

        return commonControllers;
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/controllers/common-controllers.js
// module id = 32
// module chunks = 1